export default {
  name: "new_refill_modal",
  // width: '100%',
  height: "auto",
  scrollable: true,
  pivotY: 0.1,
  pivotX: 0.5,
  clickToClose: false,
  adaptive: true,
  minWidth: 900,
};
